module.exports = "<p>\n  lead-household works!\n</p>\n"